import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

// Import i18n messages
import { translationMessages } from './i18n';

import { applyApiDefaults } from 'config/axios';
import { DEFAULT_TIMEOUT } from 'static/Constants';
import { API_ENDPOINT } from './config/env';

// import App from './App';
import RootRouter from './RootRouter';

import * as serviceWorker from './serviceWorker';
import { ConfigProvider } from 'antd';

// casl
import ability from './common/casl/ability';
import { AbilityContext } from './context/Can';

import storeApp from './store/storeApp';
import queryClient from 'config/queryClient';

import './polyfills'; // Adjust the path as necessary

import './index.less';

// Get the mount node
const MOUNT_NODE =
  document.getElementById('root') || document.createElement('div');

// init axios default baseURL
// set default timeout
applyApiDefaults(
  {
    baseURL: API_ENDPOINT,
    timeout: DEFAULT_TIMEOUT,
  },
  storeApp
);

// Create a root using the new React 18 API
const root = createRoot(MOUNT_NODE);

const render = (messages) => {
  root.render(
    <Provider store={storeApp}>
      <AbilityContext.Provider value={ability}>
        <ConfigProvider>
          <QueryClientProvider client={queryClient}>
            <RootRouter messages={messages} ability={ability} />
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </ConfigProvider>
      </AbilityContext.Provider>
    </Provider>
  );
};

if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  module.hot.accept(['./i18n'], () => {
    // No need to unmount with React 18
    render(translationMessages);
  });
}

// Chunked polyfill for browsers without Intl support
if (!window.Intl) {
  new Promise((resolve) => {
    resolve(import('intl'));
  })
    .then(() =>
      Promise.all([
        import('@formatjs/intl-relativetimeformat/polyfill'),
        import('@formatjs/intl-relativetimeformat/dist/locale-data/en'),
        import('@formatjs/intl-relativetimeformat/dist/locale-data/vi'),
      ])
    )
    .then(() => render(translationMessages))
    .catch((err) => {
      throw err;
    });
} else {
  render(translationMessages);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
